import { supabase } from '@/lib/supabase'
import type { DocumentUploadJob, UploadedFile } from '../types'

export async function getDocumentUploadJobs(
  companyId: string,
  limit: number = 10
): Promise<DocumentUploadJob[]> {
  const { data, error } = await supabase
    .from('document_upload_jobs')
    .select('*')
    .eq('company_id', companyId)
    .order('created_at', { ascending: false })
    .limit(limit)

  if (error) throw error
  return data || []
}

export async function getUploadedFiles(companyId: string): Promise<UploadedFile[]> {
  const { data, error } = await supabase
    .from('private_documents')
    .select('source_filename, source_type, source_total_chunks, file_size_bytes, created_at')
    .eq('company_id', companyId)
    .order('created_at', { ascending: false })

  if (error) throw error

  const filesMap = new Map<string, UploadedFile>()

  for (const doc of data || []) {
    if (!filesMap.has(doc.source_filename)) {
      filesMap.set(doc.source_filename, {
        source_filename: doc.source_filename,
        source_type: doc.source_type,
        total_chunks: doc.source_total_chunks || 1,
        file_size_bytes: doc.file_size_bytes,
        uploaded_at: doc.created_at,
      })
    }
  }

  return Array.from(filesMap.values())
}

export async function deleteUploadedFile(companyId: string, filename: string): Promise<void> {
  const { error } = await supabase
    .from('private_documents')
    .delete()
    .eq('company_id', companyId)
    .eq('source_filename', filename)

  if (error) throw error
}
